<div class="serviced-houses-list-container">

  <form *ngIf="formGroup" [formGroup]="formGroup">

    <lib-dropdown *ngIf="items && items.countSort"
                  [items]="items.countSort"
                  [formControlName]="'countSort'">
    </lib-dropdown>

    <lib-dropdown *ngIf="items && items.fieldSort"
                  [items]="items.fieldSort"
                  [formControlName]="'fieldSort'">
    </lib-dropdown>

    <lib-lookup [formControlName]="'search'"
                [placeholder]="'ÐÐ´ÑÐµÑ Ð¸Ð»Ð¸ ÐºÐ°Ð´Ð°ÑÑÑÐ¾Ð²ÑÐ¹ Ð½Ð¾Ð¼ÐµÑ'"
                [itemsProvider]="searchProvider">
    </lib-lookup>

  </form>

  <arm-serviced-houses-list [servicedHousesList]="servicedHousesList"
                            (activeElementEmit)="openItem($event)">
  </arm-serviced-houses-list>

  <arm-spinner *ngIf="loading" class="spinner"></arm-spinner>

  <lib-paging-controls *ngIf="paginationShow"
                       [count]="paginatorConfig.count"
                       [pageSize]="paginatorConfig.pageSize"
                       [activePage]="paginatorConfig.activePage"
                       [tailButtons]="false"
                       [prevNextButtons]="false"
                       (pageChanged)="pageChanged($event.page)">
  </lib-paging-controls>

</div>
